import "firebase/firestore";
import firebase from "firebase";
import moment from "moment";

export default {
  namespaced: true,

  state: {
    myRecords: [],
    timeLine: [],
    otherUserRecords: [],
  },
  mutations: {
    addMyRecords(state: any, { record, recordUser, commentList, likeList, }:
      { record: any; recordUser: any; commentList: any; likeList: any }) {
      record.recordUser = recordUser;
      record.commentList = commentList;
      record.likeList = likeList;
      state.myRecords.push(record);
    },
    addOtherUserRecord(state: any, { record, recordUser, commentList, likeList }: any) {
      record.recordUser = recordUser;
      record.commentList = commentList;
      record.likeList = likeList;
      state.otherUserRecords.push(record);
    },
    resetTimeLine(state: any) {
      state.timeLine = [];
    },
    resetUserRecords(state: any) {
      state.otherUserRecords = [];
    },
    addRecord(state: any,{record, recordUser, commentList, likeList,}:
      { record: any; recordUser: any; commentList: any; likeList: any }) {
        record.recordUser = recordUser;
        record.commentList = commentList;
        record.likeList = likeList;
        state.timeLine.push(record);
    },
    addComment(state: any, { commentData, recordId }: { commentData: any; recordId: any }) {
      const index = state.timeLine.findIndex((record: any) => record.recordId === recordId);
      state.timeLine[index].commentList.push(commentData);
      const otherUserRecordsIndex = state.otherUserRecords.findIndex((record: any) => record.recordId === recordId);
      state.otherUserRecords[otherUserRecordsIndex].commentList.push(commentData);
    },
    addLike(state: any, { like, recordId }: { like: any; recordId: any }) {
      const index = state.timeLine.findIndex((record: any) => record.recordId === recordId);
      state.timeLine[index].likeList.push(like);
      const otherUserRecordsIndex = state.otherUserRecords.findIndex((record: any) => record.recordId === recordId);
      if(otherUserRecordsIndex !== -1) state.otherUserRecords[otherUserRecordsIndex].likeList.push(like)
    },
    removeLike(state: any, { recordId, likeId }: { recordId: any; likeId: any }) {
      const timeLineIndex = state.timeLine.findIndex((record: any) => record.recordId === recordId);
      const timeLinelikeIndex = state.timeLine[timeLineIndex].likeList.findIndex((like: any) => like.likeId === likeId);
      state.timeLine[timeLineIndex].likeList.splice(timeLinelikeIndex, 1);
      const otherRecordIndex = state.otherUserRecords.findIndex((record: any) => record.recordId === recordId);
      if(otherRecordIndex !== -1){
        const otherRecordLikeIndex = state.otherUserRecords[otherRecordIndex].likeList.findIndex((like: any) => like.likeId === likeId);
        state.otherUserRecords[otherRecordIndex].likeList.splice(otherRecordLikeIndex, 1);
      }
    },
  },
  actions: {
    // 自分のレコードを取得する
    fetchMyRecords({ commit }: any, user: any) {
      const db = firebase.firestore();
      const userId = user.uid;
      const userName = user.displayName;
      const userPhotoURL = user.photoURL;
      const usersCollection = db.collection("users");
      const recordsCollection = db.collection("records");
      const query = recordsCollection.where("userId", "==", userId)
      query.onSnapshot((snapshot) => {snapshot.docChanges().forEach(async (change) => {
        if (change.type === 'added'){
          const recordUser = {userId: userId, userName: userName, userPhotoURL: userPhotoURL};
          const record = change.doc.data();
          const commentList: any = [];
          const likeList: any = [];
          // 各レコードに紐づくコメントを取得する
          await recordsCollection.doc(record.recordId).collection("comments").get().then(snapshot => snapshot.forEach(doc => {
            const comment = doc.data();
            comment.commentAt = comment.commentAt.seconds;
            usersCollection.doc(comment.commentUserId).get().then((doc: any) => {
              comment.commentUserName = doc.data().userName;
              comment.commentUserPhotoURL = doc.data().userPhotoURL;
              commentList.push(comment);
            });
          }));
          // 各レコードに紐づくいいねを取得する
          await recordsCollection.doc(record.recordId).collection("likes").get().then(likes => likes.forEach(doc => {
            const like = doc.data();
            usersCollection.doc(like.likeUserId).get().then((doc: any) => {
              like.likeUserName = doc.data().userName;
              like.likeUserPhotoURL = doc.data().userPhotoURL;
              likeList.push(like);
            });
          }));
          // 取得したレコードをマイレコード・タイムラインに追加する
          commit("addMyRecords", {record: record, recordUser: recordUser, commentList: commentList, likeList: likeList});
          commit("addRecord", {record: record, recordUser: recordUser, commentList: commentList, likeList: likeList});
        }
      })});
    },
    // 他ユーザーのレコードを取得する
    fetchOtherUserRecords({ commit }: any, userId: string) {
      commit("resetUserRecords");
      const db = firebase.firestore();
      const usersCollection = db.collection("users");
      const recordsCollection = db.collection("records");
      const jobsCollection = db.collection("jobs")
      usersCollection.doc(userId).get().then((doc: any) => {
        const recordUser = {
          userId: userId,
          userName: doc.data().userName,
          userPhotoURL: doc.data().userPhotoURL
        }
        recordsCollection.where("userId", "==", userId).get().then(snapshot => snapshot.forEach(async doc => {
          // レコードが非公開ジョブに紐づくものであれば取得しない
          const jobId = doc.data().jobId;
          let isPrivate = false;
          if (jobId) {
            await jobsCollection.doc(jobId).get().then((doc: any) => {
              isPrivate = doc.data().jobPublishingSetting == 3;
            });
          }
          if (!isPrivate) {
            const record = doc.data();
            const commentList: any = [];
            const likeList: any = [];
            // 各レコードに紐づくコメントを取得する
            await recordsCollection.doc(record.recordId).collection("comments").get().then(snapshot => snapshot.forEach(doc => {
              const comment = doc.data();
              comment.commentAt = comment.commentAt.seconds;
              usersCollection.doc(comment.commentUserId).get().then((doc: any) => {
                comment.commentUserName = doc.data().userName;
                comment.commentUserPhotoURL = doc.data().userPhotoURL;
                commentList.push(comment);
              });
            }));
            // 各レコードに紐づくいいねを取得する
            await recordsCollection.doc(record.recordId).collection("likes").get().then(likes => likes.forEach(doc => {
              const like = doc.data();
              usersCollection.doc(like.likeUserId).get().then((doc: any) => {
                like.likeUserName = doc.data().userName;
                like.likeUserPhotoURL = doc.data().userPhotoURL;
                likeList.push(like);
              });
            }));
            commit("addOtherUserRecord", { record: record, recordUser: recordUser, commentList: commentList, likeList: likeList });
          }
        }))
      });
    },
    // フレンドと所属グループのレコードを取得する
    fetchTimeLine({ commit }: any, user: any) {
      const db = firebase.firestore();
      const userId = user.uid;
      const usersCollection = db.collection("users");
      const recordsCollection = db.collection("records");
      const jobsCollection = db.collection("jobs");
      // 友達が作成したレコードを取得する
      usersCollection.doc(userId).collection("friends").where("friendStatus", "==", 3).onSnapshot(snapshot => snapshot.forEach(doc => {
        const friendUserId = doc.data().friendUserId;
        // フレンドの情報（名前・画像）を取得する
        usersCollection.doc(friendUserId).get().then((friend: any) => {
          const friendName = friend.data().userName;
          const friendPhotoURL = friend.data().userPhotoURL;
          const recordUser = {userId: friendUserId, userName: friendName, userPhotoURL: friendPhotoURL};
          // フレンドが作成したレコード情報を取得する
          recordsCollection.where("userId", "==", friendUserId).onSnapshot(records =>
            records.forEach(async doc => {
            // レコードが非公開ジョブに紐づくものであれば取得しない
            const jobId = doc.data().jobId;
            let isPrivate = false;
            if (jobId) {
              await jobsCollection.doc(jobId).get().then((doc: any) => {
                isPrivate = doc.data().jobPublishingSetting === 3; // 非公開
              });
            }
            if (!isPrivate) {
              const record = doc.data();
              const commentList: any = [];
              const likeList: any = [];
              // 各レコードに紐づくコメントを取得する
              await recordsCollection.doc(record.recordId).collection("comments").get().then(snapshot => snapshot.forEach(doc => {
                const comment = doc.data();
                comment.commentAt = comment.commentAt.seconds;
                usersCollection.doc(comment.commentUserId).get().then((doc: any) => {
                  comment.commentUserName = doc.data().userName;
                  comment.commentUserPhotoURL = doc.data().userPhotoURL;
                  commentList.push(comment);
                });
              }));
              // 各レコードに紐づくいいねを取得する
              await recordsCollection.doc(record.recordId).collection("likes").get().then(likes => likes.forEach(doc => {
                const like = doc.data();
                usersCollection.doc(like.likeUserId).get().then((doc: any) => {
                  like.likeUserName = doc.data().userName;
                  like.likeUserPhotoURL = doc.data().userPhotoURL;
                  likeList.push(like);
                });
              }));
              commit("addRecord", {record: record, recordUser: recordUser, commentList: commentList, likeList: likeList});
            }
            }));
        });
      }));
      // 自分が所属しているグループに関するレコードを取得する
      usersCollection.doc(userId).collection("groups").onSnapshot(snapshot => snapshot.forEach(doc => {
        const groupId = doc.data().groupId;
        recordsCollection.where("groupId", "==", groupId).onSnapshot(snapshot => {snapshot.forEach(async doc => {
          let recordUser = {};
          const record = doc.data();
          const likeList: any = [];
          const commentList: any = [];
          // レコードに紐づくユーザー情報を取得する
          await usersCollection.doc(record.userId).get().then((doc: any) => {
            recordUser = {
              userId: record.userId,
              userName: doc.data().userName,
              userPhotoURL: doc.data().userPhotoURL,
            };
          });
          // 各レコードに紐づくコメントを取得する
          await recordsCollection.doc(record.recordId).collection("comments").get().then(snapshot => snapshot.forEach(doc => {
            const comment = doc.data();
            usersCollection.doc(comment.commentUserId).get().then((doc: any) => {
              comment.commentUserName = doc.data().userName;
              comment.commentUserPhotoURL = doc.data().userPhotoURL;
              commentList.push(comment);
            });
          }));
          // 各レコードに紐づくいいねを取得する
          await recordsCollection.doc(record.recordId).collection("likes").get().then(likes => likes.forEach(doc => {
            const like = doc.data();
            usersCollection.doc(like.likeUserId).get().then((doc: any) => {
              like.likeUserName = doc.data().userName;
              like.likeUserPhotoURL = doc.data().userPhotoURL;
              likeList.push(like);
            });
          }));
          commit('addRecord', {record: record, recordUser: recordUser, commentList: commentList, likeList: likeList})
        })});
      }))
    },
    createRecord({ commit }: { commit: any }, record: any) {
      const db = firebase.firestore();
      const recordId = db.collection("records").doc().id;
      record.recordId = recordId;
      db.collection("records").doc(recordId).set(record);
    },
    addComment({ commit, rootGetters }: { commit: any; rootGetters: any },{ comment, recordId }: { comment: any; recordId: any }) {
      const db = firebase.firestore();
      const commentCollection = db.collection(`records/${recordId}/comments`);
      const commentId = commentCollection.doc().id;
      comment.commentId = commentId;
      commentCollection.doc(commentId).set(comment).then(() => {
          const commentData = comment;
          commentData.commentAt = moment(comment.commentAt).unix();
          commentData.commentUserName = rootGetters.loginUserName;
          commentData.commentUserPhotoURL = rootGetters.loginUserPhotoURL;
          commit("addComment", {
            commentData: commentData,
            recordId: recordId,
          });
        });
    },
    addLike({ commit, rootGetters }: { commit: any; rootGetters: any }, recordId: any) {
      const db = firebase.firestore();
      const userId = rootGetters.loginUserId;
      const likeCollection = db.collection(`records/${recordId}/likes`);
      const likeId = likeCollection.doc().id;
      const like: any = { likeId: likeId, likeUserId: userId };
      likeCollection.doc(likeId).set(like).then(() => {
          like.likeUserName = rootGetters.loginUserName;
          like.likeUserPhotoURL = rootGetters.loginUserPhotoURL;
          commit("addLike", { like: like, recordId: recordId });
      });
    },
    removeLike({ commit }: { commit: any }, { recordId, likeId }: { recordId: any; likeId: any }) {
      const db = firebase.firestore();
      db.collection(`records/${recordId}/likes`).doc(likeId).delete().then(() => {
        commit("removeLike", { recordId: recordId, likeId: likeId });
      });
    },
  },
  getters: {
    myRecords: (state: any) => (state.myRecords ? state.myRecords : []),
    timeLine: (state: any) => (state.timeLine ? state.timeLine : []),
    otherUserRecords: (state: any) => (state.otherUserRecords ? state.otherUserRecords : []),
  },
};
